export default {
  '成绩查询列表':'Score Inquiry List',
  '计划':'Plan',
  '请选择计划':'Select Plan',
  '查看成绩单':'View Transcript',
  '生成成绩单':'Generate Transcript',
  '学生':'Student',
}